export { Modal } from './Modal';
export type { ModalProps } from './types';
export { default } from './Modal';